import { useAppSettings, useAuth } from '@dw/hooks';
import { DANCE_SCHOOL_APP_APPEARANCE } from '@dw/models/danceSchool';

import { APP_PALETTE_DARK, APP_PALETTE_LIGHT } from '../illustrations';

/**
 * Everything `DirectoryPreview` needs to draw this school's row, resolved once.
 *
 * Both settings on this tab draw the same list, so resolving it twice is how the two pictures start
 * disagreeing about which logo the app would actually use.
 */
export const useDirectoryPreview = () => {

  const { danceSchool } = useAuth();
  const { appSettings } = useAppSettings();

  /*
    The APP's chain, which is two steps and not three: the square mark, else the letterhead one —
    the only logo every school is guaranteed to have, because it is the one that gates Active.

    It deliberately skips `schoolLogoKey`, which this portal's own header and switcher DO use. That
    mark is a portal concept the mobile app has never carried, so including it here would draw a
    logo inside a phone frame that the phone would never show. This drawing is a picture of the app;
    if the app's `getStudioSquareLogoKey` ever gains a step, this gains the same one.
  */
  const markKey = danceSchool?.squareLogoKey ?? danceSchool?.logoKey;

  /*
    Drawn on the ground the school has pinned, not always the light one. A square mark is judged
    against what is behind it, and the pin lives one section below on this same page.
  */
  const palette = danceSchool?.appAppearance === DANCE_SCHOOL_APP_APPEARANCE.DARK
    ? APP_PALETTE_DARK
    : APP_PALETTE_LIGHT;

  return {
    palette,
    schoolName: danceSchool?.name ?? 'Your studio',
    imageUrl: markKey ? `${appSettings.blobBaseUrl}/${markKey}` : undefined
  };
};
